(function() {
  var mod = {
    node: document.querySelector(".before-after-image"),
    has: function(value) {
      return typeof value !== "undefined" && value !== null && value !== "";
    },
    pointerEventToXY: function(e) {
      var out = {x:0, y:0};
      if(e.type == 'touchstart' || e.type == 'touchmove' || e.type == 'touchend' || e.type == 'touchcancel'){
        var touch = e.touches[0] || e.changedTouches[0];
        out.x = touch.pageX;
        out.y = touch.pageY;
      } else if (e.type == "click" || e.type == 'mousedown' || e.type == 'mouseup' || e.type == 'mousemove' || e.type == 'mouseover'|| e.type=='mouseout' || e.type=='mouseenter' || e.type=='mouseleave') {
        out.x = e.pageX;
        out.y = e.pageY;
      }
      return out;
    },
    checkScroll: function() {
      var rect = mod.node.getBoundingClientRect();
      if (rect.top <= window.innerHeight * 0.75) {
        setTimeout(function() {
          mod.node.classList.add("ba-start");
          setTimeout(mod.start, 500);
        }, 300);
      } else {
        setTimeout(mod.checkScroll, 100);
      }
    },
    findShortCode: function() {
      var nodes = document.querySelectorAll("p");
      for (var i=0; i<=nodes.length-1; i++) {
        var node = nodes[i];
        if (node.innerHTML.trim() === "[before-after]") {
          return node;
        }
      }
    },
    start: function() {
      if (mod.has(mod.node)) {
        // Handle shortcode if present
        var shortCode = mod.findShortCode();
        if (mod.has(shortCode)) {
          shortCode.parentElement.insertBefore(mod.node, shortCode);
          shortCode.parentElement.removeChild(shortCode);
          mod.node.style.display = "block";
        }
        
        // Always initialize the slider functionality
        mod.node.classList.add("ba-started");
        var icon = mod.node.querySelector(".ba-icon");
        var after = mod.node.querySelector(".ba-layer.ba-after");
        var afterContent = mod.node.querySelector(".ba-layer.ba-after .ba-content");
        var mouse = {x: 0, y: 0, moving: false, left: 50};
        
        var mouseDown = function(evt) {
          mouse.moving = true;
        };
        icon.addEventListener("touchstart", mouseDown);
        icon.addEventListener("mousedown", mouseDown);
        
        var mouseMove = function(evt) {
          if (mouse.moving === true) {
            var xy = mod.pointerEventToXY(evt);
            var rect = mod.node.getBoundingClientRect();
            var left = ((xy.x - rect.x) / mod.node.clientWidth) * 100;
            if (left < 0) left = 0;
            if (left > 100) left = 100;
            icon.style.left = left + "%";
            after.style.left = left + "%";
            afterContent.style.left = (left * -1) + "%";
          }
        };
        mod.node.addEventListener("touchmove", mouseMove);
        mod.node.addEventListener("mousemove", mouseMove);
        
        var mouseUp = function(evt) {
          mouse.moving = false;
        };
        mod.node.addEventListener("touchend", mouseUp);
        mod.node.addEventListener("mouseup", mouseUp);
      }
    }
  };
  mod.checkScroll();
})();